(function () {
    "use strict";
    var THRESHOLD = 1500;

    var TOTAL_FIELD = "total_price";

    var GATE_ATTR = "data-sp-fg-embed-gate";
    var STYLE_ID = "sp-fg-embed-gate-style";
    var CONTAINER_SELECTOR = ".salepify-embed-widget__embedded-list-container";
    var MAX_PATCH_ATTEMPTS = 20;
    var RETRY_DELAY_MS = 250;
    var LOG = "[Custom][Free Gift] Embed cart threshold:";

    function injectStyle() {
        if (document.getElementById(STYLE_ID)) return;
        var style = document.createElement("style");
        style.id = STYLE_ID;
        style.textContent =
            "html:not([" + GATE_ATTR + '="on"]) ' + CONTAINER_SELECTOR + "{display:none !important;}";
        (document.head || document.documentElement).appendChild(style);
    }

    function getThresholdInCartSubunits() {
        var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
        return THRESHOLD * 100 * (isFinite(rate) && rate > 0 ? rate : 1);
    }

    function applyGate(cart) {
        var total = cart ? Number(cart[TOTAL_FIELD]) : NaN;
        var isEligible = isFinite(total) && total >= getThresholdInCartSubunits();

        if (isEligible) {
            document.documentElement.setAttribute(GATE_ATTR, "on");
        } else {
            document.documentElement.removeAttribute(GATE_ATTR);
        }

        return isEligible;
    }

    function patchCartGet() {
        try {
            var app = window.tlFreeGiftOffer;
            if (!app || !app.ajaxApi || typeof app.ajaxApi.cartGet !== "function") return false;
            if (app.__spEmbedCartThresholdPatched) return true;

            var originalCartGet = app.ajaxApi.cartGet.bind(app.ajaxApi);

            app.ajaxApi.cartGet = async function () {
                var cart = await originalCartGet();
                try {
                    applyGate(cart);
                } catch (err) {
                    console.error(LOG, "loi khi ap dung gate:", err);
                }
                return cart;
            };

            app.__spEmbedCartThresholdPatched = true;
            return true;
        } catch (err) {
            console.error(LOG, "loi khi patch cartGet:", err);
            return true; // dừng retry, tránh lặp lỗi
        }
    }

    try {
        injectStyle();

        var attempts = 0;
        var timer = setInterval(function () {
            try {
                attempts++;
                if (patchCartGet() || attempts >= MAX_PATCH_ATTEMPTS) clearInterval(timer);
            } catch (tickErr) {
                console.error(LOG, "loi trong vong lap patch:", tickErr);
                clearInterval(timer);
            }
        }, RETRY_DELAY_MS);
    } catch (outerErr) {
        console.error(LOG, "loi khoi tao script:", outerErr);
    }
})();
